﻿<script>
	import { getContext } from 'svelte';

    import { registerPageComplete } from "../tealium";
    import { pageNumber, currentPage } from '../stores/pageStore';
	import model from "../stores/modelStore";
	import { isValid } from "../validation";

	import PageSection from "../components/PageSection.svelte";
	import NavigationButtons from "../components/NavigationButtons.svelte";
	import Form from "../components/Form.svelte";
	import FormRow from "../components/FormRow.svelte";
	import FormColumn from "../components/FormColumn.svelte";
	import YesNoGroup from "../components/YesNoGroup.svelte";
	import TextArea from "../components/TextArea.svelte";

	export let disabled;
    
	let buttons;
	const { displayError } = getContext("error-modal");

	const handleSubmit = async (e) => {
        //e.preventDefault();
        buttons.blockNext();

		if (isValid()) {
			registerPageComplete("Injury, Illness and Treatment",
				$model.Contact.EmailAddress,
				$model.Contact.PhoneNumber,
				$model.ReferralSource);

			let response = await model.saveModelAsync();

			if (!response.success) {
				console.log(displayError)
				displayError(response);
			} else {
				buttons.next();
			}
		}

        buttons.unblock();
		return true;
	};

	$pageNumber = ($currentPage ? $currentPage.pageIndex : 0);

</script>

<PageSection>

	<Form {disabled} id="find-details" on:submit={handleSubmit}>

		<h1>Injury or Illness Information</h1>

		<FormRow>
			<FormColumn>
				<TextArea
					required
					{disabled}
					label="In your own words, describe your injury or illness, your current symptoms and their severity"
					id="injuryDescription"
					maxlength="2000"
					rows="6"
					bind:value={$model.InjuryDescription}
					autoExpand={true}
				/>
			</FormColumn>
		</FormRow>

		<FormRow>
			<FormColumn>
				<YesNoGroup
					required
					{disabled}
					label="Is this injury or illness the main reason you stopped working?"
					name="reasonForStopWork"
					bind:value={$model.ReasonForStopWork}
					autoExpand={true}
				/>
			</FormColumn>
		</FormRow>

		<FormRow>
			<FormColumn cols="6">
				<TextArea
					required
					{disabled}
					label="When did the injury or illness occur?"
					id="whenInjuryOccur"
					maxlength="200"
					rows="2"
					bind:value={$model.WhenInjuryOccur}
					autoExpand={true}
				/>
			</FormColumn>
			<FormColumn cols="6">
				<TextArea
					required
					{disabled}
					label="How did your injury or illness occur?"
					id="howInjuryOccur"
					maxlength="255"
					rows="2"
					bind:value={$model.HowInjuryOccur}
					autoExpand={true}
				/>
			</FormColumn>
		</FormRow>

		<h1>Treatment Information</h1>

		<FormRow>
			<FormColumn>
				<TextArea
					required
					{disabled}
					label="Please provide the details of your doctors and/or health professionals that you have consulted for your injury or illness?"
					id="doctorsConsulted"
					maxlength="200"
					rows="2"
					bind:value={$model.DoctorsConsulted}
					autoExpand={true}
				/>
			</FormColumn>
		</FormRow>

		<FormRow>
			<FormColumn>
				<TextArea
					required
					{disabled}
					label="Please provide any planned or scheduled treatments you intend to undergo?"
					id="plannedTreatment"
					maxlength="200"
					rows="2"
					bind:value={$model.PlannedTreatment}
					autoExpand={true}
				/>
			</FormColumn>
		</FormRow>

		{#if !disabled}
			<FormRow>
				<FormColumn class="last">
					<NavigationButtons bind:buttons={buttons} />
				</FormColumn>
			</FormRow>
		{/if}

	</Form>
</PageSection>
